import type { Action } from "../../actions/types";

export type StoreState = string;

export const initialState = "index";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_SCREEN_NAME") {
    return action.data || "index";
  }

  return state;
}
